import youtube from "./youtube"
import Swiper, { Pagination, Autoplay, Navigation } from "swiper"
import { calculateCurrentValue } from "./media"
Swiper.use([Pagination, Autoplay, Navigation])
export default new (class BannerMainCarousel {
    constructor() {
        this.sliderContainerSelector = "carousel-banner-main"
        this.sliderPaginationSelector = "carousel-banner-main-pagination"
        this.sliderRecipesNextSelector = 'banner-recipes-next'
        this.sliderRecipesPrevSelector = 'banner-recipes-prev'
        this.handler()
    }

    handler() {
        const slider = document.querySelector(`.${this.sliderContainerSelector}`)

        if (!slider) return

        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        });
    }

    init() {
        document.querySelectorAll(`.${this.sliderContainerSelector}`).forEach((item) => {
            const arPaginationText = Array.prototype.map.call(item.querySelectorAll('.swiper-slide'), (item => item.querySelector('[data-text]')?.dataset.text));
            const swiper = new Swiper(item, {
                loop: !item.classList.contains('loop-1'),
                slidesPerView: 1.015,
                spaceBetween: 20,
                centerInsufficientSlides: true,
                allowTouchMove: false,
                navigation: {
                    nextEl: `.${this.sliderContainerSelector} .${this.sliderRecipesNextSelector}`,
                    prevEl: `.${this.sliderContainerSelector} .${this.sliderRecipesPrevSelector}`,
                },
                pagination: {
                    el: `.${this.sliderPaginationSelector}`,
                    clickable: true,
                    bulletClass: 'swiper-pagination-item',
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '">' + '<span class="swiper-pagination-text">' + arPaginationText[index] + '</span><span class="swiper-pagination-line"></span>' + '</span>';
                    },
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                breakpoints: {
                    300: {
                        slidesPerView: 1,
                        spaceBetween: 8,
                        allowTouchMove: true,
                    },
                    768: {
                        slidesPerView: 1,
                        // slidesPerView: 1.015,
                        spaceBetween: 20,
                    },
                },
            });

            item.querySelectorAll('video').forEach(video => {
                const slide = video.closest('.swiper-slide')
                const button = slide.querySelector('.button-play');
                const withoutDuration = button?.classList.contains('_without-duration');
                const cover = slide.querySelector('.video-cover');
                const title = slide.querySelector('._slide-title');
                const bAutoplay = video.hasAttribute('muted');

                button?.addEventListener('click', () => video.play());

                const showCover = () => {
                    if (bAutoplay) return;
                    button?.classList.remove('hidden');
                    cover?.classList.remove('hidden');
                    title?.classList.remove('invisible');
                }

                const hideCover = () => {
                    if (bAutoplay) return;
                    button?.classList.add('hidden');
                    cover?.classList.add('hidden');
                    title?.classList.add('invisible');
                }

                const onPlay = () => {
                    hideCover();
                    video.classList.remove('invisible');
                    swiper.autoplay.stop();
                }

                const onPause = () => {
                    showCover();
                    video.classList.add('invisible');
                    swiper.autoplay.start();
                }

                const onEnd = () => {
                    if (!swiper.slides[swiper.activeIndex].contains(video)) return;
                    showCover();
                    if (swiper.slides.length === 1 && bAutoplay) {
                        video.play();
                    } else {
                        if (swiper.activeIndex === swiper.slides.length - 1) {
                            swiper.slideTo(0);
                        } else {
                            swiper.slideNext();
                        }
                        swiper.autoplay.start();
                    }


                }

                if (bAutoplay) {
                    video.addEventListener('canplay', () => {
                        if (swiper.slides[swiper.activeIndex].contains(video)) {
                            video.play();
                        }
                    });
                    swiper.on('slideChange', (swiper) => {
                        if (swiper.slides[swiper.activeIndex].contains(video)) {
                            video.currentTime = 0;
                            video.play();
                        } else {
                            video.pause();
                        }
                    })
                } else {
                    swiper.on('slideChange', (swiper) => {
                        if (!swiper.slides[swiper.activeIndex].contains(video)) {
                            video.currentTime = 0;
                            video.pause();
                        }
                    })
                    video.addEventListener('loadedmetadata', () => {
                        if (video.duration && !withoutDuration) {
                            button.innerHTML += calculateCurrentValue(video.duration, 'video');
                        }
                    });
                    video.addEventListener('click', () => video.pause());
                }

                video.addEventListener('play', onPlay)
                video.addEventListener('pause', onPause)
                video.addEventListener('ended', onEnd)
            })
        });

        youtube.ready(() => this.onYoutubeReady());
    }

    onYoutubeReady() {
        document.querySelectorAll(`.${this.sliderContainerSelector} [data-banner-type="video_youtube"] [data-video-id]`).forEach((wrap) => {
            const slide = wrap.closest('.swiper-slide')
            const button = slide.querySelector('.button-play');
            const withoutDuration = button?.classList.contains('_without-duration');
            const cover = slide.querySelector('.video-cover');
            const title = slide.querySelector('._slide-title');
            const bAutoplay = wrap.hasAttribute('data-autoplay');
            const swiper = wrap.closest(`.${this.sliderContainerSelector}`).swiper;
            let bPlaying = false;

            const showCover = () => {
                if (bAutoplay) return;
                button?.classList.remove('hidden');
                cover?.classList.remove('hidden');
                title?.classList.remove('invisible');
            }

            const hideCover = () => {
                if (bAutoplay) return;
                button?.classList.add('hidden');
                cover?.classList.add('hidden');
                title?.classList.add('invisible');
            }

            const onPlay = () => {
                hideCover();
                swiper.autoplay.stop();
            }

            const onPause = () => {
                showCover();
                swiper.autoplay.start();
            }

            const onEnd = ({target: player}) => {
                hideCover();
                swiper.slideNext();
                swiper.autoplay.start();

                if (swiper.slides.length === 1 && bAutoplay) {
                    player.seekTo(0);
                    player.playVideo();
                }
            }


            const onReady = ({target: player}) => {
                if (swiper.slides[swiper.activeIndex].contains(wrap) && bAutoplay) {
                    player.playVideo();
                    onPlay();
                }
                if (!bAutoplay && player.getDuration() && !withoutDuration) {
                    button.innerHTML += calculateCurrentValue(player.getDuration(), 'video');
                }
            }

            const playerVars = {
                controls: 0
            };

            if (bAutoplay) {
                Object.assign(playerVars, {
                    mute: 1,
                })
            }

            const player = new YT.Player(wrap.querySelector("._youtube-container"), {
                height: "360",
                width: "640",
                videoId: wrap.dataset.videoId,
                playerVars,
                events: {
                    onReady,
                    onStateChange: (e) => {
                        if (e.data == 0) {
                            onEnd(e)
                            bPlaying = false;
                        } else if (e.data == 1) {
                            onPlay();
                            bPlaying = true;
                        } else if (e.data == 2) {
                            onPause();
                            bPlaying = false;
                        }
                    },
                },
            });

            button?.addEventListener('click', () => {
                player.seekTo(0);
                player.playVideo();
                onPlay();
            });

            if (bAutoplay) {
                swiper.on('slideChange', (swiper) => {
                    if (swiper.slides[swiper.activeIndex].contains(wrap)) {
                        player.seekTo(0);
                        player.playVideo();
                        onPlay();
                    }
                })
            } else {
                wrap.closest('.swiper-slide').addEventListener('click', (e) => {
                    if (bPlaying) player.pauseVideo();
                });
            }
        });
    }
})()
